export default __webpack_public_path__ + "static/media/invoice.50f1dc88.svg";